module.exports = __webpack_public_path__ + "static/img/HKCF_3D_Pantone_chi.589026a.png";


//////////////////
// WEBPACK FOOTER
// ./public/image/HKCF_3D_Pantone_chi.png
// module id = 84uV
// module chunks = 1